import { render, staticRenderFns } from "./ChangePriceRequests.vue?vue&type=template&id=054fcafe&scoped=true"
import script from "./ChangePriceRequests.vue?vue&type=script&lang=js"
export * from "./ChangePriceRequests.vue?vue&type=script&lang=js"
import style0 from "./ChangePriceRequests.vue?vue&type=style&index=0&id=054fcafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fcafe",
  null
  
)

export default component.exports